import {lazy} from "react"

const AppLazy = lazy(() => import("./App"))
export default AppLazy
